import { render, staticRenderFns } from "./InstaPhoto.vue?vue&type=template&id=94eefede&"
import script from "./InstaPhoto.vue?vue&type=script&lang=js&"
export * from "./InstaPhoto.vue?vue&type=script&lang=js&"
import style0 from "./InstaPhoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports